import { AccordionListProps } from '~/components/AccordionList/models';
import { pageBlockMapper } from '~/mappers/pageBlock';

import { AccordionBlock } from './models';

export const accordionMapper = ({
  pageBlock,
  ...rest
}: AccordionBlock): AccordionListProps =>
  ({
    pageBlock: pageBlockMapper(pageBlock),
    ...rest,
  } as AccordionListProps);
